var isObjectLike = function (value) {
    /**
     * isObjectLike({}) => true
     * isObjectLike([1, 2, 3]) => true
     * isObjectLike(Function) => false
     * isObjectLike(null) => false
     */
    return typeof value === 'object' && value !== null;
};
export default isObjectLike;
//# sourceMappingURL=is-object-like.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@antv/util/esm/is-object-like.js
// module id = 100
// module chunks = 3